import { AuthenticatedDataRequest } from '@eggplant/data-request'
import { SuccessMessage } from '@eggplant/pattern-library'
import { VAM_SERVICE } from '@eggplant/api-hosts'

interface Props {
  id: string
  onConnectionSuccessful: () => void
}

const SyncSuitesRequest = ({
  id,
  onConnectionSuccessful
}: Props) => {
  const handleSuccess = () => {
    onConnectionSuccessful()
  }

  const url = `${VAM_SERVICE}/repositories/${id}/sync`

  return (
    <AuthenticatedDataRequest
      method='put'
      onSuccess={handleSuccess}
      url={url}
    >
      {
        () =>
          <SuccessMessage>
            Suites & snippets sync successfully requested
          </SuccessMessage>
      }
    </AuthenticatedDataRequest>
  )
}

export default SyncSuitesRequest
